import React from 'react'
import {
    Alert,
    Box,
    Stack,
    TableHead,
    TableCell,
    Checkbox,
    Menu,
    MenuItem,
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-duotone-svg-icons/faTrash'
import { faFileExport } from '@fortawesome/pro-duotone-svg-icons/faFileExport'
import { faBell } from '@fortawesome/pro-duotone-svg-icons/faBell'
import { faBellSlash } from '@fortawesome/pro-duotone-svg-icons/faBellSlash'
import { faFolder } from '@fortawesome/pro-duotone-svg-icons/faFolder'
import { faSort } from '@fortawesome/pro-duotone-svg-icons/faSort'
import { faSortUp } from '@fortawesome/pro-duotone-svg-icons/faSortUp'
import { faSortDown } from '@fortawesome/pro-duotone-svg-icons/faSortDown'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes'
import { faBars } from '@fortawesome/pro-duotone-svg-icons/faBars'
import { faCaretDown } from '@fortawesome/pro-duotone-svg-icons/faCaretDown'
import MultiContentDossierSubscribe from '../../DefDossierToolbar/MultiContentDossierSubscribe'
import MultiContentDossierArchive from '../../DefDossierToolbar/MultiContentDossierArchive'
import ContentDossierExport from '../../DefDossierToolbar/ContentDossierExport'
import MultiContentDossierDelete from '../../DefDossierToolbar/MultiContentDossierDelete'
import AdminQuickEditMenu from '@/feature/admin/quick-edit/AdminQuickEditMenu'
import ShowEntries from '@/shared/ui/show-entries/ShowEntries'
import { StyledButton } from '@/shared/ui/buttons'
import { StyledTableRow } from '@/shared/ui/tables'

interface ListItem {
    id: string
    view?: string
    archived?: boolean
    def_dossier_def_field?: { id: string }
    settings?: { dossier_data: string }
}

interface Dossier {
    id: string
    archived?: boolean
}

interface DossierTableHeadProps {
    results: any
    actionBtns: any[]
    selected: string[]
    dossiers: any[]
    sort: any[]
    showActionModal: string
    limit: number
    pager: any
    subscriptions: any
    mode: string
    defDossierId: string
    showEmail?: boolean
    multiAdd?: React.ReactNode
    addDossier?: React.ReactNode
    filterDossier?: React.ReactNode
    kedo: any

    checkAll: (e: React.ChangeEvent<HTMLInputElement>) => void
    applySort: (e: any, item: any, order: 'ASC' | 'DESC') => void
    clearSort: (e: any, item: any) => void
    handleEntriesChange: (val: number) => void

    fetchItems: () => void
    onDeleteSuccess: () => void
    getSearchFilter: any

    setShowActionModal: (modal: string) => void
    setShowAllExportModal: (modal: string) => void

    isAllowedDd: (action: string) => boolean
    isSortable: (item: any) => boolean
    isCustomActionButton: (item: any) => boolean
    canBeArchived: () => boolean
}

const DefDossierListTableHead: React.FC<DossierTableHeadProps> = ({
    results,
    actionBtns,
    selected,
    dossiers,
    sort,
    showActionModal,
    limit,
    pager,
    subscriptions,
    mode,
    defDossierId,
    showEmail,
    multiAdd,
    addDossier,
    filterDossier,
    kedo,

    checkAll,
    applySort,
    clearSort,
    handleEntriesChange,

    fetchItems,
    onDeleteSuccess,
    getSearchFilter,

    setShowActionModal,
    setShowAllExportModal,

    isAllowedDd,
    isSortable,
    isCustomActionButton,
    canBeArchived,
}) => {
    if (!results || !results.items) return null

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const [deleteItemName, setDeleteItemName] = React.useState<
        string | undefined
    >()

    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = (action?: string) => {
        if (action && selectedDossiers.length <= 0) {
            alert(kedo.t('Select dossiers first'))
            setAnchorEl(null)
            return
        }
        if (action) setShowActionModal(action)
        setAnchorEl(null)
    }

    const ddArchiveable = canBeArchived()

    const listItems = results.items.filter(
        (item) => item.view === 'list' && !isCustomActionButton(item)
    )

    const allDossiers = results.dossiers
    const selectedItems = selected

    const selectedDossiers = allDossiers.filter((item) =>
        selectedItems.find((selectedId) => selectedId === item.id)
    )

    const getDeleteItemName = () => {
        if (selectedDossiers.length <= 0) {
            return undefined
        }

        const firstSelectedDossier = selectedDossiers[0]
        const defDossier = kedo.env().getDefDossierById(defDossierId)
        const defDossierName = defDossier
            ? kedo.env().translateItem(defDossier, 'defdossier')
            : null
        const summary = firstSelectedDossier?.summary

        if (selectedDossiers.length > 1) {
            const label = [
                defDossierName || null,
                summary ? `(${kedo.t('for_example')} ${summary})` : null,
            ]
                .filter(Boolean)
                .join(' ')

            return label || undefined
        }

        const label = [defDossierName, summary].filter(Boolean).join(' / ')

        return label || undefined
    }

    const archivedDossiers =
        ddArchiveable && selectedDossiers.find((item) => item.archived === true)

    const dearchivedDossiers =
        ddArchiveable &&
        selectedDossiers.find((item) => item.archived === false)

    const extraColumns = actionBtns.length > 0 ? 4 : 3

    return (
        <TableHead>
            <StyledTableRow
                variant="compact"
                sx={{
                    '&& .MuiTableCell-root': {
                        borderTop: 1,
                        borderTopColor: 'divider',
                        py: 1,
                    },
                }}
            >
                <TableCell colSpan={listItems.length + extraColumns}>
                    {selectedItems.length > 0 && (
                        <Box>
                            {isAllowedDd('delete') && (
                                <StyledButton
                                    variant="outlined"
                                    invert
                                    color="error"
                                    sx={{
                                        mr: 1,
                                        '&  svg ': {
                                            mr: 1,
                                        },
                                    }}
                                    onClick={(event) => {
                                        event.preventDefault()

                                        if (selectedDossiers.length <= 0) {
                                            alert(
                                                kedo.t('Select dossiers first')
                                            )
                                            return
                                        }

                                        setDeleteItemName(getDeleteItemName())
                                        setShowActionModal('delete')
                                    }}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                    <span>{kedo.t('Delete')}</span>
                                </StyledButton>
                            )}

                            <StyledButton
                                variant="outlined"
                                invert
                                color="secondary"
                                sx={{
                                    mr: 1,
                                    '&  svg ': {
                                        mr: 1,
                                    },
                                }}
                                onClick={(event) => {
                                    event.preventDefault()

                                    if (selectedDossiers.length <= 0) {
                                        alert(kedo.t('Select dossiers first'))
                                        return
                                    }

                                    setShowActionModal('export')
                                }}
                            >
                                <FontAwesomeIcon icon={faFileExport} />
                                {kedo.t('Export')}
                            </StyledButton>

                            <StyledButton
                                variant="outlined"
                                invert
                                color="secondary"
                                endIcon={
                                    <FontAwesomeIcon
                                        icon={faCaretDown}
                                        size="sm"
                                    />
                                }
                                sx={{
                                    '& .MuiButton-endIcon svg ': {
                                        fontSize: '16px',
                                    },
                                }}
                                onClick={handleMenuOpen}
                                startIcon={<FontAwesomeIcon icon={faBars} />}
                            >
                                {kedo.t('More actions')}
                            </StyledButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={() => handleMenuClose()}
                                sx={{
                                    '&  svg ': {
                                        mr: 1.5,
                                    },
                                }}
                            >
                                <MenuItem
                                    onClick={() => handleMenuClose('subscribe')}
                                >
                                    <FontAwesomeIcon icon={faBell} />
                                    {kedo.t('Subscription')}
                                </MenuItem>
                                <MenuItem
                                    onClick={() =>
                                        handleMenuClose('stopsubscription')
                                    }
                                >
                                    <FontAwesomeIcon icon={faBellSlash} />
                                    {kedo.t('Stop subscription')}
                                </MenuItem>
                                {dearchivedDossiers &&
                                    isAllowedDd('archive') && (
                                        <MenuItem
                                            onClick={() =>
                                                handleMenuClose('archive')
                                            }
                                        >
                                            <FontAwesomeIcon icon={faFolder} />
                                            {kedo.t('Archive')}
                                        </MenuItem>
                                    )}
                                {archivedDossiers && isAllowedDd('archive') && (
                                    <MenuItem
                                        onClick={() =>
                                            handleMenuClose('dearchive')
                                        }
                                    >
                                        <FontAwesomeIcon icon={faFolder} />
                                        {kedo.t('Dearchive')}
                                    </MenuItem>
                                )}
                            </Menu>
                        </Box>
                    )}

                    {showActionModal === 'delete' && (
                        <MultiContentDossierDelete
                            kedo={kedo}
                            showModal={true}
                            size="sm"
                            items={selectedItems}
                            itemName={deleteItemName}
                            mode={mode}
                            onCancel={() => setShowActionModal('')}
                            onClose={() => {
                                setShowActionModal('')
                                onDeleteSuccess()
                            }}
                        />
                    )}

                    {showActionModal === 'export' &&
                        kedo
                            .env()
                            .isAllowedDefDossier(
                                'export',
                                defDossierId,
                                kedo.user()
                            ) && (
                            <ContentDossierExport
                                showModal={true}
                                defDossierId={defDossierId}
                                filter={getSearchFilter}
                                size="sm"
                                kedo={kedo}
                                selected={selected}
                                mode={mode}
                                onCancel={() => setShowActionModal('')}
                                onClose={() => {
                                    fetchItems()
                                    setShowActionModal('')
                                }}
                            />
                        )}

                    {(showActionModal === 'subscribe' ||
                        showActionModal === 'stopsubscription') && (
                        <MultiContentDossierSubscribe
                            kedo={kedo}
                            showModal={true}
                            subscriptions={subscriptions}
                            items={selected}
                            mode={mode}
                            showActionModal={showActionModal}
                            onClose={() => {
                                fetchItems()
                                setShowActionModal('')
                            }}
                        />
                    )}

                    {(showActionModal === 'archive' ||
                        showActionModal === 'dearchive') && (
                        <MultiContentDossierArchive
                            kedo={kedo}
                            showModal={true}
                            archived={showActionModal === 'archive'}
                            checked={selected}
                            mode={mode}
                            onClose={() => {
                                fetchItems()
                                setShowActionModal('')
                            }}
                        />
                    )}

                    <Stack
                        direction="row"
                        spacing={0.5}
                        justifyContent={
                            selected.length ? 'space-between' : 'flex-start'
                        }
                        alignItems="center"
                        sx={{ mb: 1 }}
                    >
                        {multiAdd || null}
                        {mode === 'embeddedList' ? addDossier : null}
                        {mode === 'embeddedList' ? filterDossier : null}
                        {allDossiers.length > 0 &&
                        selectedItems.length <= 0 &&
                        kedo
                            .env()
                            .isAllowedDefDossier(
                                'export',
                                defDossierId,
                                kedo.user()
                            ) ? (
                            <ContentDossierExport
                                defDossierId={defDossierId}
                                kedo={kedo}
                                onClose={() => setShowAllExportModal(false)}
                                filter={getSearchFilter}
                                mode={'all'}
                            />
                        ) : null}
                        {allDossiers.length > 0 && selectedItems.length <= 0 ? (
                            <ShowEntries
                                pager={pager}
                                value={limit}
                                onChange={handleEntriesChange}
                            />
                        ) : null}
                    </Stack>
                </TableCell>
            </StyledTableRow>

            {!results || !results.dossiers || results.dossiers.length <= 0 ? (
                <Alert
                    severity={'info'}
                    variant="outlined"
                    sx={{ margin: '0 17px' }}
                >
                    {kedo.t('No items found')}
                </Alert>
            ) : (
                <StyledTableRow variant="compact">
                    <TableCell style={{ width: '3%' }}>
                        {allDossiers.length > 0 ? (
                            <Checkbox
                                checked={selected.length === dossiers.length}
                                onChange={(e) => checkAll(e)}
                                size="small"
                                sx={{ p: 0, mr: 0 }}
                            />
                        ) : null}
                    </TableCell>
                    {showEmail === true ? <TableCell /> : null}
                    <TableCell style={{ textAlign: 'center' }}>
                        <FontAwesomeIcon icon={faBell} />
                    </TableCell>
                    {listItems.map((listItem) => {
                        const sortable = isSortable(listItem)
                        let sortItem = null
                        if (
                            listItem.def_dossier_def_field &&
                            listItem.def_dossier_def_field.id
                        ) {
                            sortItem = sort.find(
                                (itList) =>
                                    itList.item.def_dossier_def_field &&
                                    itList.item.def_dossier_def_field.id ===
                                        listItem.def_dossier_def_field.id
                            )
                        } else if (
                            listItem.settings &&
                            listItem.settings.dossier_data
                        ) {
                            sortItem = sort.find(
                                (itList) =>
                                    itList.item.settings &&
                                    listItem.settings.dossier_data ===
                                        itList.item.settings.dossier_data
                            )
                        }

                        //Item is not sortable
                        if (!sortable) {
                            return (
                                <TableCell
                                    data-ddiid={listItem.id}
                                    key={listItem.id}
                                    sx={{ position: 'relative' }}
                                >
                                    {kedo
                                        .env()
                                        .translateItem(listItem, 'displayitem')}
                                    <AdminQuickEditMenu
                                        className={'list-admin-edit-buttons'}
                                        kedo={kedo}
                                        item={listItem}
                                        handleModification={fetchItems}
                                    />
                                </TableCell>
                            )
                        }

                        //Item is sortable
                        return (
                            <TableCell
                                data-ddiid={listItem.id}
                                key={listItem.id}
                                sx={{ position: 'relative' }}
                            >
                                <Box
                                    component="span"
                                    onClick={(e) =>
                                        applySort(
                                            e,
                                            listItem,
                                            sortItem && sortItem.order === 'ASC'
                                                ? 'DESC'
                                                : 'ASC'
                                        )
                                    }
                                    sx={{ cursor: 'pointer' }}
                                >
                                    {kedo
                                        .env()
                                        .translateItem(listItem, 'displayitem')}
                                    <Box
                                        component="span"
                                        sx={{
                                            ml: 0.5,
                                            ...(sortItem ? { mr: 1 } : null),
                                        }}
                                    >
                                        {sortItem ? (
                                            <FontAwesomeIcon
                                                icon={
                                                    sortItem.order === 'ASC'
                                                        ? faSortUp
                                                        : faSortDown
                                                }
                                            />
                                        ) : (
                                            <Box
                                                component="span"
                                                sx={{
                                                    color: 'text.secondary',
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faSort}
                                                />
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                                {sortItem ? (
                                    <FontAwesomeIcon
                                        icon={faTimes}
                                        onClick={(e) => clearSort(e, listItem)}
                                        size={'sm'}
                                        style={{ cursor: 'pointer' }}
                                    />
                                ) : null}
                                <AdminQuickEditMenu
                                    className={'list-admin-edit-buttons'}
                                    kedo={kedo}
                                    item={listItem}
                                    handleModification={fetchItems}
                                />
                            </TableCell>
                        )
                    })}
                    {actionBtns.length > 0 ? (
                        <TableCell>{kedo.t('Actions')}</TableCell>
                    ) : null}
                    <TableCell />
                </StyledTableRow>
            )}
        </TableHead>
    )
}

export default DefDossierListTableHead
